define('modules/form_editor/views/editor_custom_telephone',['require','exports','module','./editor_text','ldsh!../templates/editor_custom_telephone'],function(require,exports,module){
  "use strict";
  /*var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_telephone"),
    events: {
      "change .js-placeholder": "updateModel"
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("placeholder", $(e.currentTarget).val().trim());
    },
    onRender: function(){
      this.$el.i18n();
    }
  });*/

  var EditorText = require("./editor_text");
  module.exports = EditorText.extend({
    template: require("ldsh!../templates/editor_custom_telephone"),
  });
});

